<template>
    <div class="mid">
        <b-link class="back" @click="$emit('proceed', 'permissions')"><svg-icon icon="back" /></b-link>
        <h1>{{ $t('avoidDistractionsTitle') }}</h1>
        <div class="text-center">
            <p>{{ $t('avoidDistractionsText1') }}</p>
            <p><img src="/img/popupscreenshot.png" width="600" /></p>
            <p>{{ $t('avoidDistractionsText2') }}</p>
        </div>
        <b-button class="p-3 mt-5" block variant="primary" @click="$emit('proceed', 'intro')">{{ $t('continue') }}</b-button>
    </div>
</template>
<script>
import SvgIcon from '@/components/SvgIcon'
export default {
    name: "AssessmentPopup",
    components: {
        SvgIcon
    }
}

</script>